import React, {
  useState,
  useCallback,
  useEffect
} from 'react';
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { Container } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Page from 'src/components/Page';
import Header from './Header';

import useIsMountedRef from 'src/hooks/useIsMountedRef';
// import IssueDetails from './IssueDetails';
import MperitoCard from 'src/components/MperitoCard';
import { fetchONDCServerType } from 'src/actions/issuesActions';
import IssueForm from './IssueForm';


const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingTop: theme.spacing(3),
    paddingBottom: 100
  }
}));


function IssueCreate({ match, location }) {
  const {state} = useLocation();
  const dispatch = useDispatch();
  const data = state?.data;
  const [serverTypes, setServerTypes ] = useState([]);

  const classes = useStyles();

    useEffect(() => {
      const fetchONDCServerTypeData = async () => {
        try {
          const details = await dispatch(fetchONDCServerType());
          setServerTypes(details || []); // fallback to [] to avoid undefined errors
          console.log("fetchONDCServerTypeData() : ", details);
        } catch (error) {
          console.error("Error fetching issues:", error);
          setServerTypes([]);
        }
      };
      fetchONDCServerTypeData()      
    }, []);


  return (
    <Page
      className={classes.root}
      title="Issue Details"
    >
      <Container maxWidth="lg">
        <Header />
        <br/>
        <MperitoCard title={`Issue Details ( ${data?.customerId} - ${data?.issueId} )`}>
            <IssueForm serverTypes={serverTypes} />
          {/* <IssueDetails customerId={data?.customerId} issueId={data?.issueId} data={issueDetails?.issue} /> */}
          {/* <IssueDetails customerId={data?.customerId} issueId={data?.issueId} data={issueData?.data?.issue} />         */}
        </MperitoCard>
        
      </Container>
    </Page>
  );
}

export default IssueCreate;

